type Clarity = {
  (...args: unknown[]): void;
  q?: IArguments[];
};

/** Use Clarity's official queue without loading or changing any tracking scripts. */
export function reportVslClarity(...args: unknown[]) {
  const w = window as unknown as { clarity?: Clarity };
  w.clarity = w.clarity || function () {
    if (w.clarity) (w.clarity.q = w.clarity.q || []).push(arguments);
  };
  w.clarity(...args);
}

/** Tag the session once window.clarity exists (retry up to 5 s), then fall back to the queue. */
export function tagVslTest(variant: 'A' | 'B', timeout = 5000, interval = 250) {
  const send = () => {
    reportVslClarity('set', 'landing_page_variation', variant);
    reportVslClarity('set', 'vsl_test', 'short_vs_long');
  };
  const started = Date.now();
  const tick = () => {
    if ((window as unknown as { clarity?: Clarity }).clarity || Date.now() - started >= timeout) send();
    else window.setTimeout(tick, interval);
  };
  tick();
}
